import { useState } from "react";
import { Modal, TextInput } from "risa-oasis-ui_v2";
import { ModalId } from "../../../enums/modalId";
import type { RoleOption } from "../../../types";
import CustomRadioButton from "../../customRadioButton/customRadioButton";

const DEFAULT_ROLE_OPTIONS: RoleOption[] = [
  { value: "admin", label: "Admin" },
  { value: "member", label: "Member" },
];

export interface AddMemberFormData {
  name: string;
  email: string;
  role: string;
}

interface AddMemberModalProps {
  onSave: (data: AddMemberFormData) => void;
  onClose?: () => void;
  roleOptions?: RoleOption[];
}

const AddMemberModalNew = ({
  onSave,
  onClose,
  roleOptions = DEFAULT_ROLE_OPTIONS,
}: AddMemberModalProps) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("");

  const handleSave = () => {
    if (name && email && role) {
      onSave({ name, email, role });
      resetForm();
    }
  };

  const resetForm = () => {
    setName("");
    setEmail("");
    setRole("");
  };

  const handleCancel = () => {
    resetForm();
    onClose?.();
  };

  const handleInputChange = (data: { name: string; value: string }) => {
    if (data.name === "member-name") {
      setName(data.value);
    } else if (data.name === "member-email") {
      setEmail(data.value);
    }
  };

  const isFormValid = name !== "" && email !== "" && role !== "";

  return (
    <Modal
      dialogId={ModalId.ADD_MEMBER_MODAL}
      onSave={handleSave}
      onCancel={handleCancel}
      onClose={handleCancel}
      title="Add Member"
      saveButtonText="Add Member"
      cancelText="Cancel"
      disableSave={!isFormValid}
    >
      <div className="p-0">
        <div className="flex flex-col gap-4">
          <TextInput
            id="member-name"
            label="Name"
            placeholder="Enter the member name"
            onChange={handleInputChange}
            resetField={name === ""}
            required
          />
          <TextInput
            id="member-email"
            label="Email"
            placeholder="Enter the member email"
            onChange={handleInputChange}
            resetField={email === ""}
            required
          />
          <div className="mt-2">
            <div className="mb-2 text-h12 font-semiBold leading-small text-primaryGray-1">
              Select the user role
            </div>
            <div className="role-selection__radio-buttons flex flex-col gap-2">
              {roleOptions.map((option) => (
                <CustomRadioButton
                  key={option.value}
                  name="user-role"
                  value={option.value}
                  checked={role === option.value}
                  label={option.label}
                  className=""
                  onChange={(e) => setRole(e.target.value)}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddMemberModalNew;
